import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIP_ITEM_VOUCHER_PRINT_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';
/**
 * /trips/75555523444/details/23424234755/trip-voucher.pdf
 */

export class TripItemVoucherPrintController implements Controller {
  public readonly bundles = [];
  public readonly pageId = 'trip-item-voucher-print';
  public readonly routeName = 'trip-item-voucher-print';
  public readonly exact = true;
  public readonly path = '/trips/:tripViewId([a-z0-z-]+)/details/:tripItemId([a-z0-z-]+)/trip-voucher.pdf';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trip-item-voucher-print" */ 'views/trip-item-voucher-print-view')
  );
  public readonly pageName = 'page.Trip.ItemVoucherPrint';
  public readonly clickstreamPageName = 'Trip Item Voucher Print';

  public shouldStreamResponse(): boolean {
    return false;
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIP_ITEM_VOUCHER_PRINT_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trips-item-voucher-print-controller'
    });

    return Promise.resolve();
  }
}
